const size = {
  xxs: 10,
  xs: 14,
  small: 16,
  medium: 20,
  large: 64,
}

export const sizes = {
  xxs: size.xxs,
  xs: size.xs,
  small: size.small,
  medium: size.medium,
  large: size.large,
}

export default sizes
